import dayjs from 'dayjs'
import { toast } from 'react-toastify'
import api from '../../api'
import { useMerchant } from '../../../store/global/useMerchant'
import { getDepartmentUrl } from '../../functions'
import {
  buildAgendaSummary,
  formatAgendaAppointment,
  formatPurchaseHistory,
  formatServiceHistory,
} from '../../formatResponses/agendaInteligente'

const TIMEOUT_MS = 8000

async function fetchCalendarDay(date, filters) {
  const department = getDepartmentUrl()
  const { data } = await api.get('smart-schedule/appointments', {
    params: {
      date,
      department,
      status: filters.status,
      type: filters.type,
    },
    timeout: TIMEOUT_MS,
  })

  const appointments = Array.isArray(data)
    ? data
    : data?.appointments || data?.results || []

  return appointments.map(appointment =>
    formatAgendaAppointment(appointment, { date, department })
  )
}

export async function fetchAgenda(filters = {}) {
  const hoje = dayjs().format('YYYY-MM-DD')
  const amanha = dayjs().add(1, 'day').format('YYYY-MM-DD')
  const depoisDeAmanha = dayjs().add(2, 'days').format('YYYY-MM-DD')

  const requestFilters = {}
  if (filters.type !== 'todos') requestFilters.type = filters.type
  if (filters.status !== 'todos') requestFilters.status = filters.status

  const results = await Promise.allSettled([
    fetchCalendarDay(hoje, requestFilters),
    fetchCalendarDay(amanha, requestFilters),
    fetchCalendarDay(depoisDeAmanha, requestFilters),
  ])

  const failedRequests = results.filter(result => result.status === 'rejected')
  if (failedRequests.length === results.length) throw failedRequests[0].reason

  const get = (i) => results[i].status === 'fulfilled' ? results[i].value : []
  const sort = (arr) => [...arr].sort((a, b) => a.horario.localeCompare(b.horario))

  const hojeApts = sort(get(0))
  const amanhaApts = sort(get(1))
  const depoisApts = sort(get(2))

  return {
    datas: { hoje, amanha, depoisDeAmanha },
    resumo: {
      hoje: buildAgendaSummary(hojeApts),
      amanha: buildAgendaSummary(amanhaApts),
      depoisDeAmanha: buildAgendaSummary(depoisApts),
    },
    agendamentos: {
      hoje: hojeApts,
      amanha: amanhaApts,
      depoisDeAmanha: depoisApts,
    },
  }
}

export async function fetchHistoricoServicos(petId) {
  const { data } = await api.get('crm/cliente/historico-servicos', {
    params: { petId },
    timeout: TIMEOUT_MS,
  })
  return formatServiceHistory(data)
}

export async function fetchHistoricoCompras(cpf) {
  const storeId = useMerchant.getState().data.merchant?.id || ''
  const { data } = await api.get('crm/cliente/historico-compras', {
    params: { cpf, storeid: storeId },
    timeout: TIMEOUT_MS,
  })
  return formatPurchaseHistory(data)
}

export async function updateAppointmentsContacted(appointments = [], contacted = true) {
  try {
    await api.post('smart-schedule/contacted', {
      appointments,
      contacted,
    }, {
      timeout: TIMEOUT_MS,
    })

    return true
  } catch (error) {
    const message =
      error?.response?.data?.friendly_message ||
      error?.response?.data?.message ||
      'Não foi possível atualizar o status de contato.'

    toast.error(message, { theme: 'colored' })
    return false
  }
}

export async function updateAppointmentsContactStatus(appointments = [], contactStatus) {
  try {
    await api.post('smart-schedule/contact-status', {
      appointments,
      contactStatus,
    }, {
      timeout: TIMEOUT_MS,
    })

    return true
  } catch (error) {
    const message =
      error?.response?.data?.friendly_message ||
      error?.response?.data?.message ||
      'Não foi possível atualizar o status de contato.'

    toast.error(message, { theme: 'colored' })
    return false
  }
}
